// This is the single source of truth for the official roles we have in the system.
export const SYSTEM_ROLES = {
  admin: 'admin',
  financeUser: 'financeUser',
  salesUser: 'salesUser',
  readOnlyUser: 'readOnlyUser'
} as const

const SYSTEM_ROLE_LABELS = {
  [SYSTEM_ROLES.admin]: 'Admin',
  [SYSTEM_ROLES.financeUser]: 'Finance user',
  [SYSTEM_ROLES.salesUser]: 'Sales user',
  [SYSTEM_ROLES.readOnlyUser]: 'View only'
} as const

export const getSystemRoleLabel = (role: string) => {
  return SYSTEM_ROLE_LABELS[role as keyof typeof SYSTEM_ROLES]
}

export type SystemRoles = keyof typeof SYSTEM_ROLES
/**
 * Roles that have full access (CRUD) to products and pricing.
 * Used to restrict which users can be assigned as contract intake approvers.
 */
export const ROLES_WITH_FULL_PRODUCT_ACCESS = [
  SYSTEM_ROLES.admin,
  SYSTEM_ROLES.financeUser
] as Array<SystemRoles>
